import { render, staticRenderFns } from "./CompanySettingsHeader.vue?vue&type=template&id=22becb8c"
import script from "./CompanySettingsHeader.vue?vue&type=script&lang=js"
export * from "./CompanySettingsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports